module.exports = __webpack_public_path__ + "static/media/fiber.ed522c77.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/black/fiber.svg
// module id = 460
// module chunks = 0